module.exports = __webpack_public_path__ + "img/icon-arrow-last.35fbbce1.svg";